import React, { Component } from 'react';
import { Modal, Input, Button, Icon, message, Form, Select } from 'antd';
import math from 'mathjs';

import OTPForm from './OTPForm';
import { WithdrawWrapper, TitleWrapper } from './style';
import { returnComma, validAddress, minValue, maxValue, getNetworkLabelByKey } from '../../common/utils';
import { requestWithdrawal } from '../../common/fetch';
import Coins from '../../components/Coins';
import { ExclamationCircleFilled } from '@ant-design/icons';

const { Option } = Select;
const { Item } = Form;

class Withdrawal extends Component {
	state = {
		step: 1,
		address: '',
		amount: '',
		fee: 'optimal',
		isMax: false,
		selectedNetwork: ''
	};

	componentDidMount() {
		if (this.props.networks && this.props.networks.length === 1) {
			this.setState({ selectedNetwork: this.props.networks[0] });
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (JSON.stringify(this.props.networks) !== JSON.stringify(prevProps.networks)
			&& this.props.networks && this.props.networks.length === 1) {
			this.setState({ selectedNetwork: this.props.networks[0] });
		}
	}

	onCancel = () => {
		const { onCancel } = this.props;
		this.setState({ step: 1 }, onCancel);
	};

	onChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	onSelect = (v) => {
		this.setState({ fee: v });
	};

	generateInitialValues = (symbol, coins = {}, networks) => {
		const { min, withdrawal_fee, withdrawal_fees } = coins[symbol] || {};
		const initialValues = {};
		const { selectedNetwork } = this.state;

		if (selectedNetwork && withdrawal_fees && withdrawal_fees[selectedNetwork]) {
			initialValues.fee = withdrawal_fees[selectedNetwork].value || 0;
		} else if (coins[symbol]) {
			initialValues.fee = withdrawal_fee;
		} else {
			initialValues.fee = 0;
		}

		if (min) {
			initialValues.amount = min;
		}
		if (networks && networks.length === 1) {
			initialValues.network = networks[0];
		}
		return initialValues;
	};

	getDecimals = (value = 0) => {
		let result = math.format(math.number(value), { notation: 'fixed' });
		return value % 1
			? result.toString().split('.')[1]
				? result.toString().split('.')[1].length
				: 0
			: 0;
	};

	toFixed = (exponential) => {
		if (Math.abs(exponential) < 1.0) {
			let e = parseInt(exponential.toString().split('e-')[1], 10);
			if (e) {
				exponential *= Math.pow(10, e - 1);
				exponential =
					'0.' + new Array(e).join('0') + exponential.toString().substring(2);
			}
		} else {
			let e = parseInt(exponential.toString().split('+')[1], 10);
			if (e > 20) {
				e -= 20;
				exponential /= Math.pow(10, e);
				exponential += new Array(e + 1).join('0');
			}
		}
		return exponential;
	};

	setMaxAmount = () => {
		const { user, symbol = 'xht', form = {}, fees, increment_unit } = this.props;
		const amount = (user.balance[`${symbol}_available`] > fees[symbol].withdrawal_fee) ? user.balance[`${symbol}_available`] - fees[symbol].withdrawal_fee : 0
		let decimal = this.getDecimals(increment_unit);
		let decValue = this.toFixed(amount);
		let valueDecimal = this.getDecimals(decValue);

		let result = amount;
		if (decimal < valueDecimal) {
			result = decValue
				.toString()
				.substring(
					0,
					decValue.toString().length - (valueDecimal - decimal)
				);
		}

		form.setFieldsValue({ amount: result });
		this.setState({ amount: result });
	};

	setData = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const { isMax } = this.state;
				if (isNaN(parseFloat(values.amount)) && !isMax) {
				} else {
					let address = values.destination_tag
						? `${values.address}:${values.destination_tag}`
						: values.address;
					this.setState({
						step: 2,
						amount: parseFloat(values.amount),
						fee: values.fee,
						address,
						network: values.network,
						memo: values.memo
					});
				}
			}
		});
	};

	handleConfirm = () => {
		if (this.props.user && this.props.user.otp_enabled) {
			this.setState({ step: 3 });
		} else {
			this.requestWithDrawal();
		}
	};

	displayAddressField = (selectedNetwork) => {
		this.setState({ selectedNetwork });
	};

	handleSubmitOtp = (body, errorCallback = () => { }) => {
		this.requestWithDrawal(body.code, errorCallback);
	};

	requestWithDrawal = async (otp_code = '', errorCallback) => {
		const { address, amount, isMax, selectedNetwork, memo } = this.state;
		const { symbol = 'xht' } = this.props;
		const body = {
			address,
			amount,
			currency: symbol
		};
		if (otp_code) {
			body.otp_code = otp_code;
		}
		if (isMax) {
			delete body.amount;
		}
		if (selectedNetwork) {
			body.network = selectedNetwork;
		} else {
			body.network = symbol;
		}
		if (selectedNetwork === 'xlm' && memo) {
			body.memo = memo;
		}
		try {
			await requestWithdrawal(
				body
			);
			this.setState({ step: 4 });
		} catch (error) {
			const error_message = error.data && error.data.message
				? error.data.message
				: error.message;
			if (error_message.toLowerCase().indexOf('otp') > -1) {
				errorCallback();
			} else {
				message.error(error_message);
			}
		}
	};

	renderTitle = () => {
		const { symbol, fullname } = this.props;
		return (
			<TitleWrapper>
				<div className="title-wrapper">
					<div className="title">Withdraw</div>
					<Coins type={symbol.toLowerCase()} small={true} />{fullname}
				</div>
			</TitleWrapper>
		)
	}

	handleMaxValue = (balance) => (rule, value = 0, callback) => {
		if (parseFloat(value) > balance) {
			callback('Insufficient balance to proceed')
		} else {
			callback();
		}
	}

	roundNumber = (number = 0, decimals = 4) => {
		if (number && number === 0) {
			return 0;
		} else if (decimals && decimals > 0) {
			const multipliedNumber = math.multiply(
				math.fraction(number),
				math.pow(10, decimals)
			);
			const dividedNumber = math.divide(
				math.floor(multipliedNumber),
				math.pow(10, decimals)
			);
			return math.number(dividedNumber);
		} else {
			return math.floor(number);
		}
	};

	normalizeBTC = (value = 0) => {
		if (value && `${value}`.includes('.') && `${value}`.endsWith('0')) {
			return value;
		} else if (value) {
			return `${this.roundNumber(value.toString())}`;
		} else {
			return '0';
		}
	};

	renderBody = () => {
		const { fees, fullname, balance, symbol = 'xht', networks, increment_unit } = this.props;
		const { address, amount, fee, step, isMax, selectedNetwork } = this.state;
		const { getFieldDecorator } = this.props.form;
		const initialValues = this.generateInitialValues(symbol, fees, networks);
		const coinBalance = balance[`${symbol.toLowerCase()}_available`];
		if (step === 1) {
			// const disabled = address === `` || (amount === '' && !isMax);
			let coinFee = fees[symbol] || {};
			return (
				<div>
					<Form
						onSubmit={this.setData}
					>
						<div className="input-container">
							<div className='text-content'>
								{`Available ${fullname} Balance: ${coinBalance} ${symbol.toUpperCase()}`}
							</div>
							{networks.length
								?
								<Item>
									<b className='title-content'>Network</b>
									{getFieldDecorator('network', {
										initialValue: initialValues.network
									})(
										<Select
											placeholder="Select a network"
											onChange={this.displayAddressField}
										>
											{networks.map((network, index) => (
												<Option key={index} value={network}>
													{getNetworkLabelByKey(network)}
												</Option>
											))}
										</Select>
									)}
								</Item>
								: null
							}
							{selectedNetwork === "xlm"
								?
								<Item>
									<b>Memo</b>
									{getFieldDecorator('memo')(
										<Input />
									)}
								</Item>
								: null
							}
							{!selectedNetwork && networks.length
								?
								<div className="warn-text">
									<ExclamationCircleFilled />
									Make sure the network selected is compatible with the destinantion wallet
								</div>
								: null
							}
							{selectedNetwork || (networks.length === 0)
								?
								<div>
									<Item>
										<b className='title-content'>Withdraw Address</b>
										{getFieldDecorator('address', {
											rules: [
												{
													validator: validAddress(symbol, selectedNetwork)
												}
											]
										})(
											<Input
												name="address"
											/>
										)}
									</Item>
									{(symbol === 'xrp' || symbol === 'xlm')
										? <Item>
											<b>Destination tag</b>
											{getFieldDecorator('destination_tag')(
												<Input
													name="destination_tag"
												/>
											)}
										</Item>
										: null
									}
									<Item>
										<b className='title-content'>Amount</b>
										{getFieldDecorator('amount', {
											initialValue: initialValues.amount,
											normalize: this.normalizeBTC,
											rules: [
												{
													required: true,
													message: 'required'
												},
												{
													validator: minValue(coinFee.min)
												},
												{
													validator: this.handleMaxValue(coinBalance)
												},
												{
													validator: maxValue(coinFee.max)
												}
											]
										})(
											<Input
												type="number"
												name="amount"
												disabled={isMax}
												addonAfter={
													<span
														className="btn-max"
														onClick={this.setMaxAmount}
													>
														MAX
													</span>
												}
												step={increment_unit}
												min={coinFee.min}
											/>
										)}
									</Item>
									<Item>
										<b className='title-content'>Fee</b>
										{getFieldDecorator('fee', {
											initialValue: initialValues.fee
										})(
											<Input
												name="fee"
												disabled
											/>
										)}
									</Item>
								</div>
								: null
							}
						</div>
						<div className="btn-wrapper">
							<Button type="primary" block onClick={this.onCancel}>
								Back
							</Button>
							<div className="separator"></div>
							<Button
								type="primary"
								htmlType={'submit'}
								block
								// onClick={this.setData}
								// disabled={disabled}
								disabled={networks.length && !selectedNetwork}
							>
								Next
							</Button>
						</div>
					</Form>
				</div>
			);
		}
		if (step === 2) {
			let sendAmount = parseFloat(amount);
			// let coinFee = fees[symbol] || {};
			// let fee = coinFee.withdrawal_fee;
			let total = sendAmount + fee;
			return (
				<div>
					<div className="caution">Caution!</div>
					<p>
						Please ensure the accuracy of your transaction <br />
						details since transfers are irreversible.
					</p>
					<div className="confirm-box">
						Send <b>{returnComma(sendAmount)} {symbol}</b> to
						<br />
						<b>{address}</b>
						<br />
						with an added transaction fee of {returnComma(fee)} {symbol}
						<br />
						(Total {returnComma(total)} {symbol})
						<br />
						{selectedNetwork
							?
							<div>
								<b>Network</b>: {selectedNetwork}
							</div>
							: null
						}
					</div>
					<div className="btn-area">
						<Button type="info" block onClick={this.onCancel}>
							Back
						</Button>
						<Button type="primary" block onClick={this.handleConfirm}>
							Confirm
						</Button>
					</div>
				</div>
			);
		}
		if (step === 3) {
			return (
				<OTPForm
					submitCallback={this.handleSubmitOtp}
				/>
			)
		}
		if (step === 4) {
			return (
				<div style={{ textAlign: 'center', paddingTop: '12px' }}>
					<Icon type="mail" style={{ fontSize: '44px' }} />
					<div className="confirm">Confirm via Email!</div>
					<p style={{ paddingBottom: '12px' }}>
						A confirmation was sent to your email address. In order to
						complete the withdrawal process please confirm the withdrawal
						in your email within 5 minutes.
					</p>
					<div className="btn-area">
						<Button type="primary" block onClick={this.onCancel}>
							Okay
						</Button>
					</div>
				</div>
			);
		}
	};

	render() {
		const { visible, onOk, fullname, symbol = 'xht' } = this.props;
		const { step } = this.state;
		let title = '';
		switch (step) {
			case 1:
				title = this.renderTitle(fullname, symbol);
				break;
			case 2:
				title = 'Review & Confirmed';
				break;
			case 3:
				title = 'Authenticator code';
				break;
			default:
				break;
		}
		return (
			<Modal
				visible={visible}
				title={title}
				onOk={onOk}
				onCancel={this.onCancel}
				footer={null}
			>
				<WithdrawWrapper>{this.renderBody()}</WithdrawWrapper>
			</Modal>
		);
	}
}

export default Form.create({ name: 'Withdraw' })(Withdrawal);
